import { TopPartElement } from "@/custolink-views/asset_frontend/ui/TopPartElement";
import { GrBusinessService } from "react-icons/gr";

export default function ServiceAndPartsInquiryUiButton(p:{
  onClick: () => void,
  text: string
}) {
  return <TopPartElement
    icon={<GrBusinessService className={"text-xl text-primary"} />}
    onClick={p.onClick}
  >
    <div className={"text-center"}>{p.text}</div>
  </TopPartElement>
}
